module.exports = __webpack_public_path__ + "images/lp-sl-m-bg-slider-mobile.webp";